import axios from '@/libs/axios'

export const getLayouts = () => axios.get('/dynamic-import/layouts')

export const getLayout = id => axios.get(`/dynamic-import/layouts/${id}`)

export const saveLayout = data => axios.post('/dynamic-import/layouts', data)

export const deleteLayout = id => axios.delete(`/dynamic-import/layouts/${id}`)

export const duplicateLayout = id => axios.post(`/dynamic-import/layouts/${id}/duplicate`)

export const extractFile = (file, layoutId) => {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('layoutId', layoutId)
  return axios.post('/dynamic-import/extract', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export const getBatchStatus = batchId => axios.get(`/dynamic-import/batch/${batchId}`)

export const getBatchItems = batchId => axios.get(`/dynamic-import/items/${batchId}`)

export const validateBatch = batchId => axios.post(`/dynamic-import/validate/${batchId}`)

export const processBatch = batchId => axios.post(`/dynamic-import/process/${batchId}`)
